module.exports = __webpack_public_path__ + "static/media/ranking-selected.437b009c.svg";